import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantInvitationCodeEmailSerializer = {
  invitationCode: string;
  email: string;
  message: string;
};

export type PostTenantInvitationCodeEmailPayloadType = (
  Pick<TenantInvitationCodeEmailSerializer, 'invitationCode'>
);
export type PostTenantInvitationCodeEmailResponseType = (
  Pick<TenantInvitationCodeEmailSerializer, 'email' | 'message'>
);

export const apiFetchTenantInvitationCodeEmail = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostTenantInvitationCodeEmailPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.tenantInvitationCodeEmail(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
